import { Component, input, OnChanges, output, signal, SimpleChanges } from '@angular/core';
import { CropFieldAdvice } from '../../disease-overview-table.component/models/models';

@Component({
  template: '',
  standalone: true,
})
export class TableComponent implements OnChanges {

  protected readonly selectedCropFields = signal<CropFieldAdvice[]>([]);

  public readonly advices = input<CropFieldAdvice[]>([]);

  public readonly selectedCropFieldsChanged = output<CropFieldAdvice[]>();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.advices) {
      this.selectedCropFields.set([]);
      this.selectedCropFieldsChanged.emit([]);
    }
  }

  protected onRowSelectionChange(isSelected: boolean, advice: CropFieldAdvice): void {
    const currentSelectedAdvices = this.selectedCropFields();

    const updatedSelectedAdvices = isSelected
      ? [...currentSelectedAdvices, advice]
      : currentSelectedAdvices.filter((selectedAdvice) => selectedAdvice !== advice);

    this.selectedCropFields.set(updatedSelectedAdvices);
    this.selectedCropFieldsChanged.emit(updatedSelectedAdvices);
  }
}
